<template>
    <div>
        <div v-if="errors > 0" class="has-text-centered">
            <figure class="image is-96x96 is-inline-block">
                <img :src="getImage(errors)" />
            </figure>
        </div>
        <div class="py-6">
            <div
                v-for="(word, number) in words"
                :key="number"
                class="
                    columns
                    is-multiline is-mobile is-variable is-1 is-centered
                "
                @keyup="handleKeypress"
            >
                <div v-for="(letter, index) in word" :key="index">
                    <div v-if="letter != ' '" class="column is-narrow">
                        <div class="lb-hangman-input-letter has-shadow">
                            <p
                                v-if="isSelected(letter)"
                                class="has-text-weight-bold is-size-3"
                            >
                                {{ letter }}
                            </p>
                        </div>
                    </div>
                    <div v-else class="lb-hangman-input-letter"></div>
                </div>
            </div>
        </div>

        <div
            class="
                columns
                is-multiline is-mobile is-mobile is-variable is-1 is-centered
            "
        >
            <div
                v-for="(letter, index) in alphabet"
                :key="letter"
                class="column is-narrow py-1"
            >
                <div
                    :class="{
                        'has-text-success':
                            isSelected(letter) && isContained(letter),
                        'has-text-danger':
                            isSelected(letter) && !isContained(letter),
                    }"
                    class="
                        lb-hangman-input-letter
                        has-shadow has-cursor-pointer
                    "
                    @click="selectLetter(letter, index)"
                >
                    <p
                        class="has-text-weight-bold is-size-3"
                        :ref="letter + index"
                    >
                        {{ letter }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    props: {
        answers: {
            type: Array,
            default() {
                return [];
            },
        },
    },

    data() {
        return {
            alphabet: _.invoke(
                'abcçdefghijklmnñopqrstuvwxyz0123456789',
                'toUpperCase'
            ),
            selectedLetters: [],
            errors: 0,
        };
    },
    computed: {
        words() {
            return this.printableAnswer.split(' ');
        },
        printableAnswer() {
            return this.answers[0].value
                .normalize('NFD')
                .replace(/[\u0300-\u0302\u0304-\u0326\u0328-\u036f]/g, '')
                .toUpperCase();
        },
        answer() {
            return this.answers[0].value
                .normalize('NFD')
                .replace(
                    /[\u0300-\u0302\u0304-\u0326\u0328-\u036f-\u0020]/g,
                    ''
                )
                .toUpperCase();
        },
        pendingLetters() {
            return _.difference(this.answer.split(''), this.selectedLetters);
        },
    },
    mounted() {
        window.addEventListener('keyup', this.handleKeypress);
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeypress);
    },
    methods: {
        selectLetter(letter, index) {
            if (this.isSelected(letter)) {
                return;
            }
            this.selectedLetters.push(letter);
            if (this.pendingLetters.length == 0) {
                this.$emit('answer', {
                    answer: { value: this.selectedLetters },
                    correct: true,
                });
            }
            if (!this.isContained(letter)) {
                this.errors = this.errors + 1;
                this.$refs[letter + index][0].innerText = '-1';
            } else {
                this.$refs[letter + index][0].innerText = '+1';
            }
            if (this.errors == 6) {
                this.$emit('answer', {
                    answer: { value: this.selectedLetters },
                    correct: false,
                });
            }
            console.log('errors', this.errors);
        },
        isSelected(letter) {
            return _.contains(this.selectedLetters, letter);
        },
        isContained(letter) {
            return this.answer.indexOf(letter) > -1;
        },
        handleKeypress(e) {
            if (this.alphabet.indexOf(e.key.toUpperCase() > -1)) {
                this.selectLetter(e.key.toUpperCase());
            }
        },
        getImage(index) {
            return '/img/Ahorcado' + index + '.png';
        },
    },
};
</script>

<style scoped></style>
